import React from 'react'
import NavMenuItem from './NavMenuItem'
import {
  INavItemWithHeadListProps,
  NavItem,
} from '../interfaces/Navigation.Interface.Footer'

import Conditional from '../../common/Conditional'

const NavItemsWithHeadingList = ({ navItem }: INavItemWithHeadListProps) => {
  const { heading, items } = navItem
  let anchorText
  if (heading?.title != '' && heading?.absolute !== '') {
    anchorText = <a href={heading.absolute}>{heading.title}</a>
  }

  return (
    <>
      <Conditional if={heading != null}>
        <h2>{heading.absolute == '' ? heading.title : anchorText}</h2>
      </Conditional>
      <Conditional if={items != null}>
        <ul>
          {items.map((item: NavItem, index) => {
            return <NavMenuItem key={index} {...item}></NavMenuItem>
          })}
        </ul>
      </Conditional>
    </>
  )
}

export default NavItemsWithHeadingList
